import ServiceFailureAnalysis from "../components/ServiceFailureAnalysis";
import React from 'react';
import { Link } from 'react-router-dom';
import { getAllServices } from '../data/services.js';
import CTA from '../components/CTA';
import { generateCTAMessage } from '../utils/ctaMessages.js';

const ServicesPage = () => {
  const services = getAllServices();

  return (
    <>
      {/* Hero Section */}
      <section className="services-hero-section" style={{
        background: 'var(--gradient-hero)',
        position: 'relative',
        overflow: 'hidden',
        minHeight: 'clamp(80vh, 100vh, 100vh)',
        display: 'flex',
        alignItems: 'center',
        paddingTop: 'clamp(80px, 12vw, 100px)', // Account for fixed navbar
        paddingBottom: 'clamp(2rem, 6vw, 4rem)'
      }}>
        {/* Background Pattern */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(circle at 20% 80%, var(--accent-500) 0.06, transparent 50%),
            radial-gradient(circle at 80% 20%, var(--accent-400) 0.04, transparent 50%)
          `,
          zIndex: 1
        }}></div>

        {/* Floating Particles */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 2,
          pointerEvents: 'none'
        }}>
          {[...Array(8)].map((_, i) => (
            <div key={i} style={{
              position: 'absolute',
              width: '6px',
              height: '6px',
              background: 'var(--accent-400)',
              borderRadius: '50%',
              top: `${15 + i * 12}%`,
              left: `${8 + i * 15}%`,
              animation: `float ${4 + i * 0.3}s ease-in-out infinite`,
              animationDelay: `${i * 0.4}s`
            }}></div>
          ))}
        </div>

        <div className="container" style={{ position: 'relative', zIndex: 3 }}>
          <div className="row justify-content-center text-center">
            <div className="col-lg-10">
              {/* Service Icon */}
              <div className="service-icon-large mb-4" style={{
                display: 'inline-block',
                background: 'var(--primary-800)',
                border: '2px solid var(--accent-500)',
                borderRadius: 'var(--radius-full)',
                padding: 'var(--spacing-2xl)',
                backdropFilter: 'blur(15px)',
                boxShadow: 'var(--shadow-xl)'
              }}>
                <span style={{ fontSize: '4rem' }}>🚀</span>
              </div>

              <h1 style={{
                fontSize: 'clamp(2rem, 4vw, 3rem)',
                fontWeight: '800',
                color: '#ffffff',
                textShadow: 'var(--shadow-lg)',
                lineHeight: '1.2',
                marginBottom: 'var(--spacing-2xl)'
              }}>
                Comprehensive AI & Technology{' '}
                <span style={{
                  background: 'var(--gradient-primary)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}>Solutions</span>
              </h1>
              
              <h2 style={{
                fontSize: 'clamp(1.2rem, 2.5vw, 1.5rem)',
                color: 'rgba(255, 255, 255, 0.9)',
                fontWeight: '400',
                lineHeight: '1.4',
                marginBottom: 'var(--spacing-2xl)'
              }}>
                Transform your business with cutting-edge AI and technology solutions
              </h2>
              
              <p style={{
                fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
                color: 'rgba(255, 255, 255, 0.8)',
                maxWidth: '800px',
                margin: '0 auto var(--spacing-3xl)',
                lineHeight: '1.6'
              }}>
                From generative AI to custom software development, we help you transform your business with cutting-edge technology. 
                As your permanent technology partner, we provide comprehensive solutions with full support and guaranteed results.
              </p>

              {/* CTA Buttons */}
              <div className="hero-cta services-hero-cta" style={{
                display: 'flex',
                gap: 'clamp(1rem, 3vw, var(--spacing-lg))',
                justifyContent: 'center',
                flexWrap: 'wrap',
                marginBottom: 'var(--spacing-2xl)'
              }}>
                <Link to="/contact" style={{
                  background: 'var(--gradient-primary)',
                  border: 'none',
                  color: '#ffffff',
                  padding: 'clamp(1rem, 3vw, 1.4rem) clamp(2rem, 6vw, 3.5rem)',
                  borderRadius: 'clamp(40px, 8vw, var(--radius-full))',
                  fontWeight: '700',
                  fontSize: 'clamp(0.9rem, 2.5vw, 1.1rem)',
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 'clamp(0.5rem, 1.5vw, 0.75rem)',
                  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                  boxShadow: 'var(--shadow-xl)',
                  minWidth: 'clamp(200px, 40vw, 220px)',
                  justifyContent: 'center',
                  position: 'relative',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-5px)';
                  e.target.style.boxShadow = 'var(--shadow-2xl)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'var(--shadow-xl)';
                }}>
                  <i className="bi bi-rocket-takeoff" style={{
                    fontSize: 'clamp(1rem, 2.5vw, 1.1rem)'
                  }}></i>
                  Start Your Project
                </Link>
                
                <Link to="/case-studies" style={{
                  background: 'rgba(255, 255, 255, 0.08)',
                  border: '2px solid var(--accent-500)',
                  color: '#ffffff',
                  padding: 'clamp(1rem, 3vw, 1.4rem) clamp(2rem, 6vw, 3.5rem)',
                  borderRadius: 'clamp(40px, 8vw, var(--radius-full))',
                  fontWeight: '700',
                  fontSize: 'clamp(0.9rem, 2.5vw, 1.1rem)',
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 'clamp(0.5rem, 1.5vw, 0.75rem)',
                  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                  backdropFilter: 'blur(20px)',
                  minWidth: 'clamp(200px, 40vw, 220px)',
                  justifyContent: 'center',
                  position: 'relative',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-5px)';
                  e.target.style.background = 'rgba(255, 255, 255, 0.15)';
                  e.target.style.borderColor = 'var(--accent-400)';
                  e.target.style.boxShadow = 'var(--shadow-xl)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.background = 'rgba(255, 255, 255, 0.08)';
                  e.target.style.borderColor = 'var(--accent-500)';
                  e.target.style.boxShadow = 'none';
                }}>
                  <i className="bi bi-eye" style={{
                    fontSize: 'clamp(1rem, 2.5vw, 1.1rem)'
                  }}></i>
                  View Case Studies
                </Link>
              </div>

              {/* Stats */}
              <div className="row justify-content-center mt-5 g-3">
                <div className="col-md-3 col-6">
                  <div style={{
                    background: 'rgba(255, 255, 255, 0.08)',
                    backdropFilter: 'blur(20px)',
                    border: '1px solid var(--accent-500)',
                    borderRadius: 'clamp(12px, 2.5vw, var(--radius-2xl))',
                    padding: 'clamp(1rem, 3vw, var(--spacing-lg))',
                    textAlign: 'center',
                    transition: 'all 0.3s ease',
                    minHeight: 'clamp(100px, 20vw, 120px)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = 'var(--shadow-xl)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}>
                    <div style={{
                      fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
                      fontWeight: '800',
                      color: 'var(--accent-500)',
                      marginBottom: 'clamp(0.25rem, 1vw, var(--spacing-sm))',
                      lineHeight: '1'
                    }}>9+</div>
                    <div style={{
                      fontSize: 'clamp(0.75rem, 2vw, 0.9rem)',
                      color: 'rgba(255, 255, 255, 0.8)',
                      fontWeight: '500',
                      lineHeight: '1.2'
                    }}>Services</div>
                  </div>
                </div>
                <div className="col-md-3 col-6">
                  <div style={{
                    background: 'rgba(255, 255, 255, 0.08)',
                    backdropFilter: 'blur(20px)',
                    border: '1px solid rgba(14, 165, 233, 0.2)',
                    borderRadius: 'clamp(12px, 2.5vw, 20px)',
                    padding: 'clamp(1rem, 3vw, 1.5rem)',
                    textAlign: 'center',
                    transition: 'all 0.3s ease',
                    minHeight: 'clamp(100px, 20vw, 120px)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 15px 35px rgba(14, 165, 233, 0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}>
                    <div style={{
                      fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
                      fontWeight: '800',
                      color: '#0ea5e9',
                      marginBottom: 'clamp(0.25rem, 1vw, 0.5rem)',
                      lineHeight: '1'
                    }}>50+</div>
                    <div style={{
                      fontSize: 'clamp(0.75rem, 2vw, 0.9rem)',
                      color: 'rgba(255, 255, 255, 0.8)',
                      fontWeight: '500',
                      lineHeight: '1.2'
                    }}>Technologies</div>
                  </div>
                </div>
                <div className="col-md-3 col-6">
                  <div style={{
                    background: 'rgba(255, 255, 255, 0.08)',
                    backdropFilter: 'blur(20px)',
                    border: '1px solid rgba(14, 165, 233, 0.2)',
                    borderRadius: 'clamp(12px, 2.5vw, 20px)',
                    padding: 'clamp(1rem, 3vw, 1.5rem)',
                    textAlign: 'center',
                    transition: 'all 0.3s ease',
                    minHeight: 'clamp(100px, 20vw, 120px)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 15px 35px rgba(14, 165, 233, 0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}>
                    <div style={{
                      fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
                      fontWeight: '800',
                      color: '#0ea5e9',
                      marginBottom: 'clamp(0.25rem, 1vw, 0.5rem)',
                      lineHeight: '1'
                    }}>100%</div>
                    <div style={{
                      fontSize: 'clamp(0.75rem, 2vw, 0.9rem)',
                      color: 'rgba(255, 255, 255, 0.8)',
                      fontWeight: '500',
                      lineHeight: '1.2'
                    }}>Success Rate</div>
                  </div>
                </div>
                <div className="col-md-3 col-6">
                  <div style={{
                    background: 'rgba(255, 255, 255, 0.08)',
                    backdropFilter: 'blur(20px)',
                    border: '1px solid rgba(14, 165, 233, 0.2)',
                    borderRadius: 'clamp(12px, 2.5vw, 20px)',
                    padding: 'clamp(1rem, 3vw, 1.5rem)',
                    textAlign: 'center',
                    transition: 'all 0.3s ease',
                    minHeight: 'clamp(100px, 20vw, 120px)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 15px 35px rgba(14, 165, 233, 0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}>
                    <div style={{
                      fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
                      fontWeight: '800',
                      color: '#38bdf8',
                      marginBottom: 'clamp(0.25rem, 1vw, 0.5rem)',
                      lineHeight: '1'
                    }}>24/7</div>
                    <div style={{
                      fontSize: 'clamp(0.75rem, 2vw, 0.9rem)',
                      color: 'rgba(255, 255, 255, 0.8)',
                      fontWeight: '500',
                      lineHeight: '1.2'
                    }}>Support</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-grid-section" style={{
        background: 'var(--gradient-light)',
        position: 'relative',
        overflow: 'hidden',
        padding: 'clamp(3rem, 8vw, 6rem) 0'
      }}>
        {/* Background Pattern */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(circle at 20% 80%, var(--accent-500) 0.08, transparent 50%),
            radial-gradient(circle at 80% 20%, var(--accent-500) 0.06, transparent 50%)
          `,
          zIndex: 1
        }}></div>

        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <div className="row justify-content-center text-center mb-5">
            <div className="col-lg-8">
              <h2 style={{
                fontSize: 'clamp(2rem, 4vw, 3rem)',
                fontWeight: '900',
                marginBottom: 'var(--spacing-md)'
              }}>
                <span style={{ color: '#000000' }}>Comprehensive</span>{' '}
                <span style={{ 
                  background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}>Service Portfolio</span>
              </h2>
              <p style={{
                fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
                color: 'var(--primary-500)',
                lineHeight: '1.6',
                maxWidth: '600px',
                margin: '0 auto'
              }}>
                From AI-powered solutions to custom software development, we offer end-to-end services designed to transform your business operations.
              </p>
            </div>
          </div>

          {/* Mobile-First Responsive Grid */}
          <div className="row g-3 g-md-4">
            {services.map((service, index) => (
              <div key={service.id} className="col-12 mb-4 mb-md-5">
                <div className="service-card-mobile" style={{
                  background: 'rgba(255, 255, 255, 0.95)',
                  backdropFilter: 'blur(20px)',
                  borderRadius: 'clamp(12px, 3vw, 20px)',
                  padding: 'clamp(1rem, 4vw, 2rem)',
                  boxShadow: '0 8px 30px rgba(0, 0, 0, 0.1)',
                  border: '1px solid rgba(14, 165, 233, 0.2)',
                  position: 'relative',
                  overflow: 'hidden',
                  transition: 'all 0.3s ease',
                  marginBottom: 'clamp(1rem, 3vw, 1.5rem)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 25px 50px rgba(14, 165, 233, 0.15)';
                  e.currentTarget.style.borderColor = 'rgba(14, 165, 233, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 12px 40px rgba(0, 0, 0, 0.08)';
                  e.currentTarget.style.borderColor = 'rgba(14, 165, 233, 0.15)';
                }}>
                  {/* Background Pattern */}
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: `
                      radial-gradient(circle at 30% 20%, rgba(14, 165, 233, 0.05) 0%, transparent 50%),
                      radial-gradient(circle at 70% 80%, rgba(14, 165, 233, 0.03) 0%, transparent 50%)
                    `,
                    zIndex: 1
                  }}></div>

                  {/* Mobile-First Layout */}
                  <div style={{ position: 'relative', zIndex: 2 }}>
                    {/* Service Header - Mobile Optimized */}
                    <div style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: 'clamp(0.75rem, 3vw, 1rem)',
                      marginBottom: 'clamp(1rem, 3vw, 1.5rem)'
                    }}>
                      {/* Service Icon */}
                      <div style={{
                        width: 'clamp(50px, 10vw, 70px)',
                        height: 'clamp(50px, 10vw, 70px)',
                        background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
                        borderRadius: 'clamp(10px, 2.5vw, 16px)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        fontSize: 'clamp(1.2rem, 3.5vw, 1.8rem)',
                        boxShadow: '0 6px 20px rgba(14, 165, 233, 0.3)',
                        flexShrink: 0
                      }}>
                        <i className={`bi ${service.icon}`}></i>
                      </div>
                      
                      {/* Service Title & Subtitle */}
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <h2 style={{
                          fontSize: 'clamp(1.3rem, 4vw, 1.8rem)',
                          fontWeight: '700',
                          color: '#1e293b',
                          marginBottom: 'clamp(0.25rem, 1vw, 0.5rem)',
                          lineHeight: '1.2',
                          wordBreak: 'break-word'
                        }}>{service.title}</h2>
                        
                        <p style={{
                          fontSize: 'clamp(0.9rem, 2.2vw, 1rem)',
                          color: '#64748b',
                          fontWeight: '600',
                          margin: 0,
                          lineHeight: '1.3'
                        }}>{service.subtitle}</p>
                      </div>
                    </div>
                    
                    {/* Service Description */}
                    <p style={{
                      fontSize: 'clamp(0.85rem, 2vw, 0.95rem)',
                      color: '#64748b',
                      lineHeight: '1.6',
                      marginBottom: 'clamp(1.25rem, 3vw, 1.75rem)'
                    }}>{service.description}</p>

                    {/* Challenges & Benefits - Mobile Stack */}
                    <div style={{ 
                      display: 'flex', 
                      flexDirection: 'column', 
                      gap: 'clamp(1rem, 3vw, 1.25rem)',
                      marginBottom: 'clamp(1.5rem, 4vw, 2rem)'
                    }}>
                      {/* Challenges Card */}
                      <div style={{
                        background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.08) 0%, rgba(239, 68, 68, 0.04) 100%)',
                        border: '1px solid rgba(239, 68, 68, 0.2)',
                        borderRadius: 'clamp(10px, 2.5vw, 14px)',
                        padding: 'clamp(0.875rem, 2.5vw, 1.25rem)',
                        transition: 'all 0.3s ease'
                      }}>
                        <h5 style={{
                          color: '#dc2626',
                          fontSize: 'clamp(0.85rem, 2vw, 0.95rem)',
                          fontWeight: '700',
                          marginBottom: 'clamp(0.5rem, 1.5vw, 0.75rem)',
                          display: 'flex',
                          alignItems: 'center',
                          gap: 'clamp(0.375rem, 1vw, 0.5rem)'
                        }}>
                          <i className="bi bi-exclamation-triangle"></i>
                          Key Challenges
                        </h5>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                          {service.challenges.slice(0, 3).map((challenge, index) => (
                            <li key={index} style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              gap: 'clamp(0.375rem, 1vw, 0.5rem)',
                              marginBottom: 'clamp(0.375rem, 1vw, 0.5rem)',
                              fontSize: 'clamp(0.75rem, 1.8vw, 0.85rem)',
                              color: '#7f1d1d',
                              lineHeight: '1.4'
                            }}>
                              <i className="bi bi-x-circle" style={{
                                color: '#dc2626',
                                fontSize: 'clamp(0.65rem, 1.5vw, 0.75rem)',
                                marginTop: '0.125rem',
                                flexShrink: 0
                              }}></i>
                              <span>{challenge}</span>
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* Benefits Card */}
                      <div style={{
                        background: 'linear-gradient(135deg, rgba(34, 197, 94, 0.08) 0%, rgba(34, 197, 94, 0.04) 100%)',
                        border: '1px solid rgba(34, 197, 94, 0.2)',
                        borderRadius: 'clamp(10px, 2.5vw, 14px)',
                        padding: 'clamp(0.875rem, 2.5vw, 1.25rem)',
                        transition: 'all 0.3s ease'
                      }}>
                        <h5 style={{
                          color: '#16a34a',
                          fontSize: 'clamp(0.85rem, 2vw, 0.95rem)',
                          fontWeight: '700',
                          marginBottom: 'clamp(0.5rem, 1.5vw, 0.75rem)',
                          display: 'flex',
                          alignItems: 'center',
                          gap: 'clamp(0.375rem, 1vw, 0.5rem)'
                        }}>
                          <i className="bi bi-check-circle"></i>
                          Benefits You'll Get
                        </h5>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                          {service.benefits.slice(0, 3).map((benefit, index) => (
                            <li key={index} style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              gap: 'clamp(0.375rem, 1vw, 0.5rem)',
                              marginBottom: 'clamp(0.375rem, 1vw, 0.5rem)',
                              fontSize: 'clamp(0.75rem, 1.8vw, 0.85rem)',
                              color: '#166534',
                              lineHeight: '1.4'
                            }}>
                              <i className="bi bi-check-circle" style={{
                                color: '#16a34a',
                                fontSize: 'clamp(0.65rem, 1.5vw, 0.75rem)',
                                marginTop: '0.125rem',
                                flexShrink: 0
                              }}></i>
                              <span>{benefit}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    {/* CTA Button - After Benefits */}
                    <div style={{ 
                      textAlign: 'center',
                      marginTop: 'clamp(1rem, 3vw, 1.5rem)'
                    }}>
                      <Link to={`/services/${service.id}`} style={{
                        background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
                        border: 'none',
                        color: '#ffffff',
                        padding: 'clamp(0.75rem, 2.5vw, 1rem) clamp(1.5rem, 4vw, 2rem)',
                        borderRadius: 'clamp(8px, 2vw, 12px)',
                        fontWeight: '700',
                        fontSize: 'clamp(0.9rem, 2.2vw, 1rem)',
                        textDecoration: 'none',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 'clamp(0.375rem, 1vw, 0.5rem)',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 6px 20px rgba(14, 165, 233, 0.3)',
                        minWidth: 'clamp(140px, 30vw, 180px)'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 10px 30px rgba(14, 165, 233, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 6px 20px rgba(14, 165, 233, 0.3)';
                      }}>
                        <span>Learn More</span>
                        <i className="bi bi-arrow-right"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      {/* Why Projects Fail | How We Add Value Section */}
      <ServiceFailureAnalysis serviceId="general" />
      <CTA {...generateCTAMessage('page', { type: 'services' })} />

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(180deg); }
        }
      `}</style>
    </>
  );
};

export default ServicesPage; 